import React, { useContext, useEffect, useState } from "react";
import "./shipementReport.css";
import FilterAltOutlinedIcon from "@mui/icons-material/FilterAltOutlined";
import ListIcon from "@mui/icons-material/List";
import Loading from "../../../order_managment/screens/loading/Loading";
import {
  Backdrop,
  CircularProgress,
  Paper,
  Table,
  TableContainer,
} from "@mui/material";
import ColumnSelectModelCo2 from "./Modal/ColumnSelectModelCo2";
import FilterModelShipmentReportCo2 from "./Modal/FilterModelShipmentReportCo2";
import axios from "axios";
import { path } from "../../../order_managment/constants/apiPath";
import ShipmentReportTableHead from "./ShipmentReportTableHead";
import ShipmentReportTableBody from "./ShipmentReportTableBody";
import { HOST_URL } from "../../../config";
import InfiniteScroll from "react-infinite-scroller";
import NoData from "../../../order_managment/screens/noData/NoData";
import { filterKeyCo2 } from "./shipementReportFilterObj";
import { StoreContext } from "../../../order_managment/store";
import { NotificationManager } from "react-notifications";

const ShipmentReportCo2 = () => {
  const context = useContext(StoreContext);
  const [loadmoreData, setLoadMoreData] = useState(false);
  const [orderBy, setOrderBy] = useState("desc");
  const [order, setOrder] = useState("");
  const [loading, setLoading] = useState(true);
  const [hasMore, setHasMore] = useState(false);
  const [pageNumber, setPageNumber] = useState(1);
  const [coloumn, setColoumn] = useState([]);
  const [reportInformation, setReportInformation] = useState([]);
  const [bodyData, setBodyData] = useState({ ...filterKeyCo2 });
  const [backDropLoader, setBackDropLoader] = useState(false);
  const [selectModal, setSelectModal] = useState({
    filter: false,
    selectCol: false,
  });
  
  const onLoadMore = () => {
    const count = pageNumber + 1;
    if (hasMore) {
      setLoadMoreData(true);
      // !loading && getInformaiton(order, orderBy, count, { ...bodyData });
      getInformaiton(order, orderBy, count, { ...bodyData });
    }
  };

  const getColoumn = async () => {
    let config = {
      method: "get",
      maxBodyLength: Infinity,
      url: `${HOST_URL}${path.SHIPMENT_COLOUM_CO2}`,
      headers: {
        Username: JSON.parse(localStorage.getItem("UserDataLogin")).user_name,
        Usersecret: JSON.parse(localStorage.getItem("UserDataLogin")).password,
        Macaddress: "",
        Ipaddress: "",
        Devicetype: "W",
      },
    };
    await axios
      .request(config)
      .then((response) => {
              // Map the columns to rename specific ones and keep the rest unchanged
      // const updatedColumns = response?.data?.value.map((col) => {
      //   switch (col.captionColumnName) {
      //     case "CE_ShipmentDestinationETA":
      //       return { ...col, displayColumnName: "Shipment ETA" };
      //     case "CE_ShipmentOriginETD":
      //       return { ...col, displayColumnName: "Shipment ETD" };
      //     case "CE_TotalAmount":
      //       return { ...col, displayColumnName: "CO2 Emission Value (Kg)" };
      //     default:
      //       return col; // Keep the column as is if it doesn't match any of the cases
      //   }
      // });
      
      // setColoumn(updatedColumns);
      const updatedColumns = response?.data?.value.map((col) => {
        switch (col.captionColumnName) {
          case "CE_ShipmentDestinationETA":
            return { ...col, displayColumnName: "Shipment ETA" };
          case "CE_ShipmentOriginETD":
            return { ...col, displayColumnName: "Shipment ETD" };
          case "CE_TotalAmount":
            return { ...col, displayColumnName: "CO2 Emission Value (Kg)" };
          default:
            return col; // Keep the column as is if it doesn't match any of the cases
        }
      });

      // Filter out the unwanted columns "Destination Country" and "Origin Country"
      const filteredColumns = updatedColumns.filter(
        (col) =>
          col.displayColumnName !== "Destination Country" &&
          col.displayColumnName !== "Origin Country"
      );

      setColoumn(filteredColumns);
        // setColoumn(response?.data?.value);
      })
      .catch((error) => {
        console.log(error);
      });
      setPageNumber(1);
       await getInformaiton(order, orderBy, 1, { ...bodyData });
  };

  const onFillterHandler = (body) => {
    setLoading(true);
    setOrder(""); // Reset the sorting column
    setOrderBy("desc"); // Reset the sorting direction, or set to default
    setPageNumber(1);
    getInformaiton(order, orderBy, 1, { ...body }); // Clear the sort column in the API call
    setBodyData({ ...body });
  };
  const columnMapping = {
    "Shipment ETD": "shipmentOriginETD", // Custom mapping
    "Shipment ETA": "shipmentDestinationETA", // Custom mapping
    "CO2 Emission Value (Kg)": "totalAmount", // Custom mapping
  };
  const handleRequestSort = (property) => {
    setBackDropLoader(true);
    const isAsc = order === property && orderBy === "asc";
    const newOrderBy = isAsc ? "desc" : "asc";
    const sortColumn = columnMapping[property] || property;
    setOrder(property);
    setOrderBy(newOrderBy);
     setPageNumber(1); // Reset to first page on sort
    getInformaiton(sortColumn, newOrderBy, 1, { ...bodyData });
  };
  const handleRequestColoumnUpdate = () => {
    setLoading(true);
    setOrder(""); // Reset the sorting column
    setOrderBy("desc"); // Reset the sorting direction, or set to default
    setPageNumber(1); // Ensure the page number resets to 1 when columns are updated
    getInformaiton("", "desc", 1, { ...bodyData }); // Clear the sort column in the API call
  };
  const getInformaiton = async (

    SortColumn = order,
    SortDirection = orderBy,
    PageNumber = pageNumber,
    bodyData
  ) => {
  
    setHasMore(false);
    const data = {
      ...bodyData,
      SortColumn: SortColumn?.split(" ")?.join(""),
      SortDirection,
      PageNumber,
      PageSize: 20,
    };
    let config = {
      method: "post",
      maxBodyLength: Infinity,
      url: `${HOST_URL}${path.SHIPMENT_DATA_CO2}`,
      headers: {
        Username: JSON.parse(localStorage.getItem("UserDataLogin")).user_name,
        Usersecret: JSON.parse(localStorage.getItem("UserDataLogin")).password,
        Macaddress: "",
        Ipaddress: "",
        Devicetype: "W",
      },
      data: data,
    };

    axios
      .request(config)
      .then((response) => {
        if (PageNumber == 1) {
          console.log("is condition adjfasdjflsad");
          setReportInformation(response?.data?.value ?? []);
        } else {
          console.log("else condition adjfasdjflsad");
          setReportInformation((prev) => [...prev, ...response?.data?.value]);
        }
        setPageNumber(PageNumber);
        // console.log(
        //   response?.data?.totalItem > PageNumber  * 20,
        //   "internal informaiton"
        // );
         setHasMore(response?.data?.totalItem > PageNumber * 20);
      })
      .catch((error) => {
        console.log(error);
      })
      .finally(() => {
        setLoading(false);
        setLoadMoreData(false);
        setBackDropLoader(false);
      });
  };

   
  useEffect(() => {
    getColoumn();
  }, []);

  const downloadExcelFile = (base64Data = "") => {
    try {
      const contentType =
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
      const byteCharacters = atob(base64Data);
      const byteNumbers = Array.from(byteCharacters, (char) =>
        char.charCodeAt(0)
      );
      const byteArray = new Uint8Array(byteNumbers);
      const blob = new Blob([byteArray], { type: contentType });
      const url = URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "CO2_REPORT.xlsx");
      document.body.appendChild(link);
      link.click();

      setTimeout(() => {
        URL.revokeObjectURL(url);
        document.body.removeChild(link);
      }, 0);
    } catch (error) {
      console.error("Error downloading file:", error);
      NotificationManager.error("Error downloading file", "", 3000);
    }
  };

  const onDownload = () => {
    context.setBackDropOpen(true);
    const data = {
      ...bodyData,
      SortColumn: "",
      SortDirection: "",
      PageNumber: 1,
      PageSize: 20,
    };

    const config = {
      method: "post",
      url: `${HOST_URL}${path.DOWNLOAD_SHIPMENT_REPORT_CO2}`,
      headers: {
        Username: JSON.parse(localStorage.getItem("UserDataLogin")).user_name,
        Usersecret: JSON.parse(localStorage.getItem("UserDataLogin")).password,
        Macaddress: "",
        Ipaddress: "",
        Devicetype: "W",
      },
      data,
    };

    axios
      .request(config)
      .then((response) => {
        downloadExcelFile(response?.data?.value);
      })
      .catch((error) => {
        console.error("Error downloading report:", error);
        NotificationManager.error("Error downloading report", "", 3000);
      })
      .finally(() => {
        context.setBackDropOpen(false);
      });
  };

  return (
    <>
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={backDropLoader}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <div className="_systemLog">
        <div className="_sytemSortDialog">
          <div className="_systemLogFilterParent">
            <div
              className="_systemLogFilter"
              onClick={() =>
                setSelectModal({
                  filter: true,
                  selectCol: false,
                })
              }
            >
              <FilterAltOutlinedIcon />
            </div>
            <div
              className="_systemLogFilter"
              onClick={() =>
                setSelectModal({
                  filter: false,
                  selectCol: true,
                })
              }
            >
              <ListIcon />
            </div>
          </div>

          <div className="_outlineButton">
            <button
              disabled={reportInformation.length === 0}
              onClick={onDownload}
            >
              Download Report
            </button>
          </div>
        </div>

        <div className="_tableScroll _systemLogTable reportTable" >
          {loading ? (
            <Loading />
          ) : (
            <TableContainer
              component={Paper}
              className="_tableScrollTableContainer"
            >
              {!reportInformation.length ? (
                <NoData>
                  <p>Report not Found!</p>
                </NoData>
              ) : (
                <InfiniteScroll
                 className="infiniteScroller"
                  pageStart={0}
                  loadMore={onLoadMore}
                  hasMore={hasMore}
                  // threshold={4}
                  // loader={
                  //   <div className="loader" key={0}>
                  //     <Loading />
                  //   </div>
                  // }
                  useWindow={false}
                >
                  <Table stickyHeader id="downloadTable">
                    <ShipmentReportTableHead
                      coloumn={coloumn}
                      handleRequestSort={handleRequestSort}
                      orderBy={orderBy}
                      order={order}
                    />
                    <ShipmentReportTableBody
                      coloumn={coloumn}
                      reportInformation={reportInformation}
                    />
                  </Table>
                  {loadmoreData && (
                    <div style={{ height: "70px" }}>
                      <Loading  />
                    </div>
                  )}
                </InfiniteScroll>
              )}
            </TableContainer>
          )}
        </div>
      </div>
      {selectModal.selectCol && (
        <ColumnSelectModelCo2
          setSelectModal={setSelectModal}
          selectModal={selectModal}
          coloumn={coloumn}
          setColoumn={setColoumn}
          setPageNumber={setPageNumber}
          pageNumber={pageNumber}
          handleRequestColoumnUpdate={handleRequestColoumnUpdate}
        />
      )}
      {selectModal.filter && (
        <FilterModelShipmentReportCo2
          onFillterHandler={onFillterHandler}
          setSelectModal={setSelectModal}
          selectModal={selectModal}
          bodyData={bodyData}
        />
      )}
    </>
  );
};

export default ShipmentReportCo2;
